var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c(
        "el-form",
        {
          ref: "form",
          attrs: { model: _vm.form, rules: _vm.rules, "label-width": "80px" },
        },
        [
          _c(
            "el-row",
            { staticClass: "row-bg", attrs: { type: "flex", justify: "end" } },
            [
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.handleAgree },
                    },
                    [_vm._v("同意")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: { click: _vm.handleDisagree },
                    },
                    [_vm._v("驳回")]
                  ),
                  _c("el-button", { on: { click: _vm.handleCancel } }, [
                    _vm._v("关闭"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            { attrs: { shadow: "hover" } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", [_vm._v("审批信息")]),
              ]),
              _c(
                "el-form-item",
                { attrs: { label: "申请人" } },
                [
                  _c("el-input", {
                    attrs: { disabled: true },
                    model: {
                      value: _vm.form.flow.assigneeName,
                      callback: function ($$v) {
                        _vm.$set(_vm.form.flow, "assigneeName", $$v)
                      },
                      expression: "form.flow.assigneeName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "开始时间" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.startTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "startTime", $$v)
                              },
                              expression: "form.startTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "结束时间" } },
                        [
                          _c("el-input", {
                            attrs: { disabled: true },
                            model: {
                              value: _vm.form.endTime,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "endTime", $$v)
                              },
                              expression: "form.endTime",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "请假理由" } },
                [
                  _c("el-input", {
                    attrs: { disabled: true, type: "textarea" },
                    model: {
                      value: _vm.form.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "reason", $$v)
                      },
                      expression: "form.reason",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "批复意见" } },
                [
                  _c("el-input", {
                    attrs: { type: "textarea" },
                    model: {
                      value: _vm.form.comment,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "comment", $$v)
                      },
                      expression: "form.comment",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            { attrs: { shadow: "hover" } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", [_vm._v("流程信息")]),
              ]),
              _c(
                "el-row",
                { staticClass: "row-bg", attrs: { type: "flex" } },
                [
                  _c(
                    "el-timeline",
                    _vm._l(_vm.flowList, function (flow) {
                      return _c(
                        "el-timeline-item",
                        {
                          key: flow.id,
                          attrs: {
                            timestamp: flow.createTime,
                            placement: "top",
                          },
                        },
                        [
                          _c("el-card", { attrs: { shadow: "hover" } }, [
                            _c("p", [
                              _vm._v(
                                _vm._s(flow.assigneeName) +
                                  " 在 [" +
                                  _vm._s(flow.createTime) +
                                  "] 开始处理 [" +
                                  _vm._s(flow.historyActivityName) +
                                  "] 环节"
                              ),
                            ]),
                            flow.historyActivityDurationTime !== ""
                              ? _c("p", [
                                  _vm._v(
                                    "任务历时 [" +
                                      _vm._s(flow.historyActivityDurationTime) +
                                      "]"
                                  ),
                                ])
                              : _vm._e(),
                            flow.comment !== ""
                              ? _c("p", [
                                  _vm._v(
                                    "批复意见: [" + _vm._s(flow.comment) + "]"
                                  ),
                                ])
                              : _vm._e(),
                            flow.endTime !== ""
                              ? _c("p", [
                                  _vm._v(
                                    "结束时间: [" + _vm._s(flow.endTime) + "]"
                                  ),
                                ])
                              : _vm._e(),
                          ]),
                        ],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            { attrs: { shadow: "hover" } },
            [
              _c("div", { attrs: { slot: "header" }, slot: "header" }, [
                _c("span", [_vm._v("流程跟踪")]),
              ]),
              _c("el-row", { staticClass: "row-bg", attrs: { type: "flex" } }, [
                _c("img", { attrs: { src: _vm.src, alt: "design" } }),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }